export const APIENDPOINTS = {
  DASHBOARD: {
    approvalDownload: '/iam/v1/dashboard/approval-request/download',
    usersURL: '/iam/v1/user',
    usersRole: '/iam/v1/user',
    downloadUser: '/iam/v1/downloadUser',
    downloadOrg: '/iam/v1/downloadOrganization',
    downloadPartner: '/iam/v1/downloadPartner',
    fetchDropDowndata: '/iam/v1/data',
    postData: '/post',
    branchDetails: '/iam/v1/branch',
    downloadBranch: '/iam/v1/downloadBranch',
    downloadEnquiry: '/report/v1/downloadEnquiry',
    downloadCustomer: '/report/v1/downloadCustomer',
    downloadApproval: '/iam/v1/approvalRequests/download',
    fetchPincode: 'iam/v1/getStateDistricts',
    bulkEsignDownload: 'esign/v1/bulk/template/status/list/download',
		getVendorDocFile: '/esign/v1/stamp/vendor/digitalStamps/fileData',
    enquiry: 'iam/v1/enquiry',
    forgotPassword: 'iam/v1/forgotPassword',
    displayEnquiry: '/iam/v1/enquiry',
    approvalRequests: '/iam/v1/approvalRequests',
    organization: '/iam/v1/organization',
    getEsignDocument: '/iam/v1/getEsignDashboard',
    bulk: '/iam/v1/branch/bulk',
    bulkUser: '/iam/v1/user/bulk',
    esignDraft: '/report/v1/dashboard/esign-draft',
    esignAwaitingSigning: '/report/v1/dashboard/esign-awaiting-signing',
    esignSigned: '/report/v1/dashboard/esign-signed',
    esignCustomerRejected: '/report/v1/dashboard/esign-customer-rejected',
    approvalSent: '/report/v1/dashboard/approval-sent',
    approvalApproved: '/report/v1/dashboard/approval-approved',
    approvalRejected: '/report/v1/dashboard/approval-rejected',
    digitalStampOrder: '/esign/v1/stamp/order-request',
    digitalStampOrderRequest: '/esign/v1/stamp/org/order-request',
    digitalStampOrderGetState: '/esign/v1/stamp/states',
    digitalStampAwaitingApproval: '/esign/v1/stamp/org/awaiting-approval',
    digitalStampViewDetails: '/esign/v1/stamp/org/details',
    digitalStampOrderConfirmed: '/esign/v1/stamp/org/order-confirmed',
    digitalStampOrderRejected: '/esign/v1/stamp/org/rejected',
    digitalStampOrderInventory: '/esign/v1/stamp/org/inventory',
    approvalRequest: '/iam/v1/approval-request',
    approvalRequestStamp: '/report/v1/approval-request/stamp',
    approvalRequestEsign: '/report/v1/approval-request/e-sign',
    approvalRequestStampApprove: '/report/v1/approval-request/stamp/approve',
    approvalRequestStampReject: '/report/v1/approval-request/stamp/reject',
    approvalRequestEsignApprove: '/report/v1/approval-request/e-sign/approve',
    approvalRequestEsignReject: '/report/v1/approval-request/e-sign/reject',
    proteanStampRequest: '/esign/v1/stamp/protean/request',
    proteanForwardToVendor: '/esign/v1/stamp/protean/forwarded-to-vendor',
    proteanOrder: '/esign/v1/stamp/protean/orders',
    proteanForwardToCustomers: '/esign/v1/stamp/protean/forwarded-to-customers',
    vendorStampRequest: '/esign/v1/stamp/vendor/request-orders',
    vendorAcceptedOrder: '/esign/v1/stamp/vendor/accepted-orders',
    vendorRejectedOrder: '/esign/v1/stamp/vendor/rejected-orders',
    vendorSentOrder: '/esign/v1/stamp/vendor/sent-orders',
    digitalStampProteanViewDetails: '/esign/v1/stamp/protean/details',
    cancelProteanOrder: 'esign/v1/stamp/protean/forwarded-to-vendor/cancel',
    vendorOrderViewDetails: '/esign/v1/stamp/vendor/details',
    deleteDocumentId: '/wfms/v1/esign',
    vendorUploadDoc: '/esign/v1/stamp/vendor/upload',
    getVendorDoc: '/esign/v1/stamp/vendor/digitalStamps',
    vendorList: '/esign/v1/stamp/protean/vendor',
    auditTrail: '/wfms/v1/esign/audit',
    courierVendor: '/esign/v1/stamp/vendor/courier',
    fetchLocationByPincode: '/report/v1/location',
    NotifyRecipientEmail: '/wfms/v1/esign/recipient',
    NotifyRecipientPayment: '/wfms/v1/esign/payment-mail/sent',
    NotifyRecipientChecker: '/wfms/v1/esign/checker',
    NotifyRecipientSendEmail: '/wfms/v1/esign/recipient',
    NotifyPayeeRecipientSendEmail: '/wfms/v1/esign/payment-mail/sent',
    uamCount: '/iam/v1/count/uam',
    downloadReportDocumennts: 'report/v1/deshboard/download',
    downloadDocumennts: 'esign/v1/stamp/download',
    downloadSampleTemplate: '/esign/v1/template/sample/download',
    downloadSampleTemplateBulkUpload: '/esign/v1/template/bulk-upload/sample/download',
    downloadTemplate: '/esign/v1/template/download',
    uploadBulkTemplate: '/wfms/v1/upload/bulk/esign',
    approvalRequestEsignAction: '/wfms/v1/approval-request/e-sign/',
    getBulkTemplateStatus: '/esign/v1/bulk/template/status/list',
    downloadBulkTemplateStatusDetails: '/esign/v1/bulk/document/status/download',
    getPendingPaymentList: '/report/v1/dashboard/esign-pending-payment',
    getDashboardCount: '/iam/v1/count/dashboard/document',
    resentMail: '/wfms/v1/resend-mail',
    download: '/esign/v1/stamp/order/download',
    digitalStampDocument: '/esign/v1/stamp/protean/details'
  },
  LOGIN: {
    login: 'iam/v1/login',
    logout: 'iam/v1/logout',
    validateToken: '/iam/v1/forgotPassword/token',
    resetPassword: '/iam/v1/forgotPassword/set',
    brandType: '/iam/v1/branding',
    auth: '/iam/v1/auth',
    menu: '/iam/v1/menu',
    refreshToken: '/iam/v1/refreshToken',
    googleAuth: '/iam/v1/google-auth-url',
    azureAuth: '/iam/v1/azure-auth-url',
    accessTokenUsingGoogle: '/iam/v1/google-sso',
    accessTokenUsingAzure: '/iam/v1/azure-sso',
    sendOtp: '/iam/v1/login/send-otp',
    verifyOtp: '/iam/v1/login/verify-otp',
    resendOtp: '/iam/v1/login/resent-otp'
  },
  SETTING: {
    modifyDepartment: '/iam/v1/department',
    roles: '/iam/v1/role',
    allPermissions: '/iam/v1/permission',
    grouping: '/iam/v1/groupSettings',
    brand: '/iam/v1/branding',
    globalSettings: '/iam/v1/globalSettings',
    setting: '/iam/v1/setting',
    webhook: '/notify/v1/webhook',
    smsConfiguration: '/esign/v1/organization/sms/config',
    emailConfiguration: '/esign/v1/organization/email/config',
    stateMaster: '/esign/v1/state/master/globlesetting/',
    pgConfiguration: '/esign/v1/organization/pg/config',
    planManagement: '/iam/v1/setting-plan',
    termsAndConditions: '/esign/v1/organization/term_conditions/configuration',
    smsTemplate: '/esign/v1/template/sms',
    emailTemplate: '/esign/v1/template/email',
    dmsProvider: '/wfms/v1/dms-provider',
    dmsTestConnection: 'wfms/v1/dms/test-connection',
    smsTestConnection: 'wfms/v1/sms/test-connection',
    emailTestConnection: 'wfms/v1/email/test-connection',
    paymentTestConnection: 'wfms/v1/pg/test-connection'
  },
  TEMPLATE_ENGINE: {
    template: '/esign/v1/template',
    template_name_availability: '/esign/v1/template/name'
  },
  NEW_ESIGN: {
    step1: '/wfms/v1/esign/step1',
    addRecipient: '/wfms/v1/esign/step2/recipient',
    getState: '/iam/v1/getState',
    getDenomination: '/wfms/v1/esign/step2/digitalStamp',
    NewESignsent: '/wfms/v1/esign/step3/sent',
    saveStampDetails: '/wfms/v1/esign/step2/stamp',
    avalibleCoordinates: '/wfms/v1/get-avalible-coordinates',
    getConfig: '/wfms/v1/esign/config',
    getSteps: '/wfms/v1/esign/estamp',
    getFinalPDF: '/wfms/v1/esign/pdf-from-template'
  },
  SAVED_ESIGN: {
    esign: '/wfms/v1/esign',
    filedata: '/wfms/v1/esign/file-data',
    singlefiledata: '/wfms/v1/esign/single-file-data',
    update: '/wfms/v1/esign/document',
    getDeafultCordinate: '/wfms/v1/get-default-coordinates'
  },
  REGISTRATION: {
    registration: '/iam/v1/organization',
    organisationType: '/iam/v1/getOrganizationTypes',
    fileId: '/iam/v1/fileData',
    individualUser: '/iam/v1/individual-customer',
    uploadDocument: '/iam/v1/organization/upload/documents'
  },
  EDITOR: {
    esign: '/wfms/v1/esign'
  },
  PROFILE: {
    uploadPic: '/iam/v1/profile'
  },

  WALLET_PROTEAN: {
    getProteanWallet: '/esign/v1/wallet/top-up',
    putProteanWallet: '/esign/v1/wallet/top-up',
    requestTransaction: '/esign/v1/wallet/request-transaction',
    accountLedger: '/esign/v1/wallet/account-ledger',
    eSignConsumption: '/esign/v1/wallet/e-sign-consumption',
    balance: '/esign/v1/wallet/balance',
    approvalSent: '/esign/v1/wallet/approval-sent',
    approvalApproved: '/esign/v1/wallet/approval-approved',
    approvalRejected: '/esign/v1/wallet/approval-rejected',
    approval: '/esign/v1/wallet/approval-request',
    approveApproval: '/esign/v1/wallet/approval-request/approve',
    rejectApproval: '/esign/v1/wallet/approval-request/reject',
    finOps: '/report/v1/approval-request/fin-ops',
    stampApproveFinOps: '/report/v1/approval-request/stamp/approve',
    stampRejectFinOps: '/report/v1/approval-request/stamp/reject',
    historyWorkflow: '/report/v1/history/workflow',
    downloadStampProcurement: '/report/v1/approval-request/downloadStampProcurement',
    ESignConsumptionDownload: '/esign/v1/wallet/e-sign-consumption-download',
    accountLedgerDownload: '/esign/v1/wallet/account-ledger-download',
    requestTransactionDownload: '/esign/v1/wallet/request-transaction-download',
    workflowDownload: '/report/v1/history/workflow/download',
    razorpayPayment: '/esign/v1/wallet/pg/top-up',
    walletTopupstatus: '/esign/v1/wallet/pg/top-up',
    vpaDetails: '/esign/v1/wallet/pg/vpa-details',
    vpaDetailsProtean: '/esign/v1/wallet/pg/vpa-details',
    groupingBranchList: '/esign/v1/organization/grouping-branch-list',
    manageBillingProfiles: '/esign/v1/organization/billing-profile',
    invoiceBill: '/esign/v1/organization/invoice-bill',
    smsHistory: '/report/v1/history/sms',
    emailHistory: '/report/v1/history/email',
    getWalletDocCount: 'iam/v1/count/wallet',
    getWalletHistoryTabCount: 'iam/v1/count/history',
    download: '/esign/v1/wallet/approval-download'
  },
  STATISTIC_OVERVIEW: {
    piechartWorkFlow: '/report/v1/graph/workflow',
    states: '/report/v1/graph/master',
    barchart: '/report/v1/graph/orders',
    viewPopupWorkFlow: '/report/v1/graph/view-details/workflow',
    viewPopUpOrders: '/report/v1/graph/view-details/orders'
  },
  SIGNATURE: {
    uploadSignature: '/iam/v1/upload/signature'
  },
  ARTICLECODE: {
    articleCode: '/esign/v1/state/master/article-code'
  },
  INVENTORY: {
    inventory: '/esign/v1/stamp/org/inventory',
    state: '/esign/v1/state',
    inventoryStatus: '/esign/v1/stamp/org/inventory/status'
  }
};
